import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.lessons');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU, getAdminT } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-admin-lessons',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.lessons/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageAdminLessonsComponent implements OnInit, OnDestroy {
    public ru = RU;
    public t: any = RU;
    public categories: any[] = [];
    public selectedCategory: string = '';
    public list: any[] = [];
    public loading: boolean = true;
    public searchText: string = '';

    public showModal: boolean = false;
    public editing: any = null;
    public form: any = {};
    public saving: boolean = false;
    private langListener: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.t = getAdminT();
        this.langListener = async () => { this.t = getAdminT(); await this.service.render(); };
        window.addEventListener('admin-lang-change', this.langListener);
        await this.loadCategories();
    }

    ngOnDestroy() {
        if (this.langListener) window.removeEventListener('admin-lang-change', this.langListener);
    }

    public async loadCategories() {
        const { code, data } = await wiz.call("categories");
        if (code === 200) {
            this.categories = data || [];
            if (this.categories.length > 0 && !this.selectedCategory) {
                this.selectedCategory = this.categories[0].id;
            }
        }
        await this.loadLessons();
    }

    public async onCategoryChange() {
        this.searchText = '';
        await this.loadLessons();
    }

    public async onSearch() {
        await this.loadLessons();
    }

    public async loadLessons() {
        if (!this.selectedCategory) {
            this.list = [];
            this.loading = false;
            await this.service.render();
            return;
        }

        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list", { category_id: this.selectedCategory, search: this.searchText });
        if (code === 200) {
            this.list = data || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public openCreate() {
        this.editing = null;
        this.form = {
            category_id: this.selectedCategory,
            title_ru: '',
            title_ko: '',
            description_ru: '',
            sort_order: this.list.length,
            status: 'active'
        };
        this.showModal = true;
        this.service.render();
    }

    public openEdit(item: any) {
        this.editing = item;
        this.form = {
            category_id: item.category_id || this.selectedCategory,
            title_ru: item.title_ru || '',
            title_ko: item.title_ko || '',
            description_ru: item.description_ru || '',
            sort_order: item.sort_order || 0,
            status: item.status || 'active'
        };
        this.showModal = true;
        this.service.render();
    }

    public closeModal() {
        this.showModal = false;
        this.editing = null;
        this.service.render();
    }

    public async save() {
        if (!this.form.title_ru || !this.form.title_ko) {
            await this.service.modal.error("Заполните название урока (рус/кор) (레슨 이름을 입력하세요)");
            return;
        }

        this.saving = true;
        await this.service.render();

        let res;
        if (this.editing) {
            res = await wiz.call("update", { id: this.editing.id, ...this.form });
        } else {
            res = await wiz.call("create", this.form);
        }

        this.saving = false;

        if (res.code === 200) {
            this.closeModal();
            await this.loadLessons();
        } else {
            await this.service.modal.error(res.data?.message || "Ошибка сохранения (저장 오류)");
            await this.service.render();
        }
    }

    public async delete(item: any) {
        const confirmed = await this.service.modal.show({
            title: 'Удалить урок? (레슨 삭제?)',
            message: `«${item.title_ru}» будет удалён. (삭제됩니다.)`,
            action: 'Удалить (삭제)',
            status: 'error'
        });
        if (!confirmed) return;

        const { code } = await wiz.call("delete", { id: item.id });
        if (code === 200) {
            await this.loadLessons();
        }
    }

    public async toggleStatus(item: any) {
        const newStatus = item.status === 'active' ? 'inactive' : 'active';
        await wiz.call("update", { id: item.id, status: newStatus });
        await this.loadLessons();
    }

    public async moveUp(item: any, index: number) {
        if (index === 0) return;
        const prev = this.list[index - 1];
        await wiz.call("update", { id: item.id, sort_order: prev.sort_order });
        await wiz.call("update", { id: prev.id, sort_order: item.sort_order });
        await this.loadLessons();
    }

    public async moveDown(item: any, index: number) {
        if (index >= this.list.length - 1) return;
        const next = this.list[index + 1];
        await wiz.call("update", { id: item.id, sort_order: next.sort_order });
        await wiz.call("update", { id: next.id, sort_order: item.sort_order });
        await this.loadLessons();
    }

    public getCategoryName(id: string) {
        const cat = this.categories.find((c: any) => c.id === id);
        return cat ? cat.title_ru : '';
    }
}

export default PageAdminLessonsComponent;